import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Oval } from 'react-loader-spinner'
import "../ModalAdmin.scss"
import { vistaConsultorasContext } from '../../../Admin/superAdmin/VistaConsultorasAdmin';
import { useAdmin } from '../../../../context/AdminContext';

function ModalConsultora(props) {

    const { 
        user,
        idConsultora, 
        setIdConsultora,
        objConsul,
        setObjConsul
    } = useContext(vistaConsultorasContext)

    const { fetchConsultoras, setLoadingConsultoras } = useAdmin()

    const [objConsultora, setObjConsultora] = useState({
        nombre: "",
        nombreEmpleado: "",
        mailEmpleado: ""
    })

    const [modalErr, setModalErr] = useState(null)
    const [errors, setErrors] = useState({})

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(objConsul){
            const obj = JSON.parse(objConsul)
            setObjConsultora((prev) => ({
                ...prev,
                nombre: obj.nombre
            }))
        }
    },[objConsul])

    const handleClose = () => {
        setObjConsultora({
            nombre: "",
            nombreEmpleado: "",
            mailEmpleado: ""
        })
        setModalErr(null)
        setErrors({})
        setObjConsul(null)
        setIdConsultora(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedUser = {
            ...objConsultora,
            [name]: value,
        };
        setObjConsultora(updatedUser);
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()){
            errors.nombre = "Ingrese un nombre."
        }
        if(!data.nombreEmpleado.trim()){
            errors.nombreEmpleado = "Escriba el nombre del empleado."
        }
        if(!data.mailEmpleado.trim()) {
            errors.mailEmpleado = "Escriba el mail."
        } else if (!/\S+@\S+\.\S+/.test(data.mailEmpleado)){
            errors.mailEmpleado = "El email no es válido."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(objConsultora)
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0) {
            setModalErr(null)
            setLoading(true)
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/addConsultora`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        user,
                        nombreConsultora: objConsultora.nombre
                    })
                })
                const data = await res.json()
                if(data.error !== 0){
                    setModalErr(data.errorDetalle)
                } else {
                    const obj = {
                        user,
                        idConsultora: data.objeto.id_consultora,
                        fk_puesto: 2,
                        nombre: objConsultora.nombreEmpleado,
                        mail: objConsultora.mailEmpleado
                    }
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/addUser`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(obj)
                        })
                        const dataEmpleado = await response.json()
                        const errorCode = dataEmpleado.status ?? dataEmpleado.error
                        if(errorCode !== 0){
                            setModalErr(dataEmpleado.errorDetalle || dataEmpleado.codeError)
                        } else {
                            props.onHide()
                            setErrors({})
                            setModalErr(null)
                            // actualizar consultoras
                            setLoadingConsultoras(true)
                            fetchConsultoras(user)
                        }
                    } catch (error) {
                        setModalErr("Error: Conexión con backend.")
                    }
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const handleChangeConsultora = async (e) => {
        e.preventDefault()
        if(!objConsultora.nombre.trim()) {
            setErrors((prev) => ({
                ...prev,
                nombre: "Ingrese un nombre."
            }))
        } else {
            setModalErr(null)
            setLoading(true)
            const obj = {
                user,
                idConsultora,
                nombreConsultora: objConsultora.nombre
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/editConsultora`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.error !== 0){
                    setModalErr(data.errorDetalle)
                } else {
                    props.onHide()
                    setErrors({})
                    setModalErr(null)
                    setObjConsul(null)
                    setIdConsultora(null)
                    // actualizar consultoras
                    setLoadingConsultoras(true)
                    fetchConsultoras(user)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        }
    }

    return (
        <>
            {loading && <div className='loading__modalEmpleado' role='status'>
                    <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#fff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='text-white fw-medium'>Loading...</p>
                </div>
            }
            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                className='modal__consultoras'
                dialogClassName={props.dialogClassName}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                        {objConsul ? <h3 className='m-0'>Modificar consultora</h3>: <h3 className='m-0'>Agregar consultora</h3>}
                        <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {objConsul ? (
                        <form className='form__consultoras d-flex flex-column' onSubmit={handleChangeConsultora}>
                            <div className='mb-4 col-12'>
                                <label className='mb-1'>Nombre de la consultora</label>
                                <input 
                                    onChange={(e)=>setObjConsultora((prev) => ({...prev, nombre: e.target.value}))}
                                    type="text" 
                                    id="nombre"
                                    name='nombre'
                                    autoFocus
                                    className="form-control form-control-sm"
                                    value={objConsultora.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                            >
                                Modificar consultora
                            </button>
                        </form>
                    ) : (
                        <form className='form__consultoras d-flex flex-column' onSubmit={handleSubmit}>
                            {/* Nombre consultora */}
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre de la consultora</label>
                                <input 
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombre"
                                    name='nombre'
                                    autoFocus
                                    className="form-control form-control-sm"
                                    value={objConsultora.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            {/* Nombre del empleado consultora */}
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre del consultor</label>
                                <input
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombreEmpleado" 
                                    name="nombreEmpleado"
                                    className="form-control form-control-sm col-12"
                                    value={objConsultora.nombreEmpleado}
                                />
                                {errors.nombreEmpleado && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombreEmpleado}</span>}
                            </div>
                            {/* Email del empleado consultora */}
                            <div className='mb-4'>
                                <label className='mb-1'>Correo</label>
                                <input
                                    onChange={handleChange}
                                    type="email" 
                                    id="mailEmpleado" 
                                    name="mailEmpleado" 
                                    placeholder="usuario@correo.com.ar" 
                                    className="form-control form-control-sm col-12"
                                    value={objConsultora.mailEmpleado}
                                />
                                {errors.mailEmpleado && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.mailEmpleado}</span>}
                            </div>
                            {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                            >
                                Agregar consultora
                            </button>
                        </form>
                    )}    
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalConsultora